import React, {useContext} from 'react'
import { Switch, Route ,useHistory } from "react-router-dom";
import { useLocalize } from 'localize-react';
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import { getStartGif, getStartJpg, getLogo }  from './LocalizedPictures'
import { setNewAnswer, calculateResult, clearAllAnswer } from '../Store'
import './Home.css'
import { AppContext} from '../contexts/AppProvider'

function Home({}) {
    const history = useHistory();
    const { settings } = useContext(AppContext)
    const { translate } = useLocalize()

    clearAllAnswer();
    
    return (

        <div className="home">
            <div className="up">
                <img id="cloud1" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} className="cloud" src={cloud1} alt="" />
                <img id="cloud2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  className="cloud3" src={cloud2} alt="" />
                <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                <img className="star2 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                <img className="star3 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
              
                <img className="firstGif" src={settings.isAnimationPause ? getStartJpg() : getStartGif()} alt="" />
            </div>
            <div className="gifHolder">
                <div onClick={() => { history.push(`/Q/1`) }} className="takeToTest">
                {translate('How much does the bank charge us?')}
                
                </div>
                <div className="reslogo home">
                    <img width="150" src={getLogo()} alt="" />
                </div>
            </div>
        </div>


    )
}



export default Home

